/* eslint-disable */
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OrderDto, fixOrderDtoFromJson } from '../dto/order-dto';

export function httpGetProductGetOrders(http: HttpClient, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<OrderDto[]>;
export function httpGetProductGetOrders(http: HttpClient, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<OrderDto[]>>;
export function httpGetProductGetOrders(http: HttpClient, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get<OrderDto[]>(`{placeholder}/Product/GetOrders`, options as any).pipe(
    tap((eventOrDto) => {
      const dto = eventOrDto instanceof HttpResponse ? eventOrDto.body : options.observe === 'events' ? null : eventOrDto as unknown as OrderDto[];
      dto?.forEach((x, i, a) => fixOrderDtoFromJson(a[i]));
    })
  );
};

export const urlGetProductGetOrders = (baseUrl: string) => {
  return `${baseUrl}/Product/GetOrders`;
};
